var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2271_181)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    transform: "matrix(1 0 0 -1 0 90)",
    fill: "url(#paint0_linear_2271_181)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2271_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2728 18H26.8131C21.9535 18 18 21.9535 18 26.8131V34.071C18 38.9304 21.9535 42.8841 26.8131 42.8841H37.9339C38.536 39.9298 41.1543 37.7 44.2837 37.7C47.4131 37.7 50.0314 39.9299 50.6334 42.8841H62.2728C67.1323 42.8841 71.0859 38.9306 71.0859 34.071V26.8131C71.0859 21.9535 67.1324 18 62.2728 18ZM30.7853 28.7886C31.6441 28.7886 32.3406 29.4848 32.3406 30.3439C32.3406 31.2028 31.6443 31.8992 30.7853 31.8992H28.472V35.6263C28.472 36.4852 27.7757 37.1816 26.9167 37.1816C26.0576 37.1816 25.3614 36.4853 25.3614 35.6263V25.258C25.3614 24.3991 26.0576 23.7027 26.9167 23.7027H31.1191C31.9779 23.7027 32.6744 24.399 32.6744 25.258C32.6744 26.117 31.9781 26.8133 31.1191 26.8133H28.472V28.7888L30.7853 28.7886ZM43.3325 34.5987C43.9 35.2434 43.8374 36.2262 43.1926 36.7937C42.5478 37.3611 41.5651 37.2985 40.9976 36.6537L38.1146 33.378V35.6261C38.1146 36.485 37.4184 37.1814 36.5593 37.1814C35.7003 37.1814 35.004 36.4852 35.004 35.6261V25.2578C35.004 24.399 35.7003 23.7025 36.5593 23.7025H39.3179C41.7452 23.7025 43.7201 25.609 43.7201 27.9524C43.7201 29.7376 42.5735 31.2681 40.9542 31.8966L43.3325 34.5987ZM51.8038 28.8868C52.6627 28.8868 53.3591 29.5831 53.3591 30.4421C53.3591 31.3012 52.6628 31.9975 51.8038 31.9975H49.3123V34.0712H52.1258C52.9847 34.0712 53.6811 34.7674 53.6811 35.6265C53.6811 36.4855 52.9849 37.1818 52.1258 37.1818H47.757C46.8981 37.1818 46.2016 36.4855 46.2016 35.6265V25.2582C46.2016 24.3993 46.8979 23.7029 47.757 23.7029H52.1258C52.9847 23.7029 53.6811 24.3991 53.6811 25.2582C53.6811 26.1172 52.9849 26.8135 52.1258 26.8135H49.3123V28.8872L51.8038 28.8868ZM61.8471 28.8868C62.7059 28.8868 63.4024 29.5831 63.4024 30.4421C63.4024 31.3012 62.7061 31.9975 61.8471 31.9975H59.3557V34.0712H62.1693C63.0281 34.0712 63.7246 34.7674 63.7246 35.6265C63.7246 36.4855 63.0283 37.1818 62.1693 37.1818H57.8004C56.9415 37.1818 56.2451 36.4855 56.2451 35.6265V25.2582C56.2451 24.3993 56.9413 23.7029 57.8004 23.7029H62.1693C63.0281 23.7029 63.7246 24.3991 63.7246 25.2582C63.7246 26.1172 63.0283 26.8135 62.1693 26.8135H59.3557V28.8872L61.8471 28.8868ZM40.6099 27.9524C40.6099 28.5699 40.0184 29.0918 39.318 29.0918C39.0282 29.0918 38.5724 29.0936 38.1146 29.0955V26.813H39.318C40.0182 26.8131 40.6099 27.3349 40.6099 27.9524ZM60.6139 59.1623V64.3465C60.6139 68.0685 57.5967 71.0859 53.8745 71.0859H44.226C42.0068 71.0859 39.8885 70.1346 38.414 68.4759L32.4821 61.8026C31.9025 61.1506 31.5824 60.3086 31.5824 59.4364C31.5824 56.3764 35.1865 54.7411 37.4892 56.7561L40.914 59.7526V44.18C40.914 42.319 42.4227 40.8103 44.2837 40.8103C46.1447 40.8103 47.6534 42.319 47.6534 44.18V52.4229H53.8745C57.5965 52.4229 60.6139 55.4402 60.6139 59.1623Z",
    fill: "url(#paint1_linear_2271_181)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_181",
    x1: 45,
    y1: 90,
    x2: 45,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_181",
    x1: 44.543,
    y1: 71.0859,
    x2: 44.543,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA68D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3A84"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2271_181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2271_181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/Free.53cd09e3b289547eb18012a55a4ea1e3.svg";
export { ForwardRef as ReactComponent };